import React from 'react';
import { Image } from 'react-native';
import { Icons } from '../../Components';
import type { CompanyProps, EventProps, PublicPlayerProps, SquaresCompetitionProps } from '../../types';
import moment from 'moment-mini';
import { useColors } from '../../constants/useColors';
import { Button, View, Text } from '../../Components/Themed';

type SquaresCompetitionCardProps = {
    squares_competition:SquaresCompetitionProps,
    admin?:PublicPlayerProps,
    event?:EventProps
    company?:CompanyProps,
    onSelectCompetition:(sq:SquaresCompetitionProps) => void
}
 
const SquaresCompetitionCard = ({ squares_competition, admin, event, company, onSelectCompetition }:SquaresCompetitionCardProps) => {
    const Colors = useColors()
    let current_payout = squares_competition.potential_winnings
    if(squares_competition.guaranteed_payout && squares_competition.guaranteed_payout > current_payout){ current_payout = squares_competition.guaranteed_payout }
    const is_live = moment().isAfter(moment(squares_competition.begin_datetime)) ? true : false
    const is_closed = squares_competition.complete_ind ? true : false
    return (
        <Button float style={{ padding:0 }} onPress={() => onSelectCompetition(squares_competition)}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Image
                    source={{ uri: squares_competition.image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:45, width:45, borderRadius:4}}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h2'>{squares_competition.sq_comp_name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>{squares_competition.sq_comp_description}</Text>
                </View>
                <Text size={20} color={Colors.text.action} weight='bold'>${squares_competition.minimum_square_price}</Text>
            </View>
            <View type='body' style={{ padding:10 }}>
                <View type='row'>
                    {event ?
                    <View transparent style={{ flex:1, flexDirection:'row', marginRight:10, borderRightWidth:1, borderColor:Colors.borders.light }}>
                        <View style={{ flexDirection:'row', alignItems:'center' }}>
                            <Image
                                source={{ uri: event.away?.image?.url }}
                                style={{ height:30, width:30 }}
                                resizeMode='cover'
                            />
                            <Text style={{ padding:5 }} theme='h2'>VS</Text>
                            <Image
                                source={{ uri: event.home?.image?.url }}
                                style={{ height:30, width:30 }}
                                resizeMode='cover'
                            />
                        </View>
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text theme='h2'>{event.event_title}</Text>
                            <Text style={{ marginTop:3 }} theme='description'>{event.time_detail == 'scheduled' ? moment(event.scheduled_datetime).format('MMM DD hh:mm a') : event.time_detail}</Text>
                        </View>
                    </View>
                    :<></>}
                    <View transparent style={{ justifyContent:'center', alignItems:'center' }}>
                        <Icons.SquaresIcon size={24} color={Colors.text.h1} />
                        <Text style={{ marginTop:3 }} theme='h2'>AUCTION</Text>
                    </View>
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                {company ?
                <Image
                    source={{ uri: company.company_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:4}}
                    resizeMode='cover'
                />
                :admin ?
                <Image
                    source={{ uri: admin.profile_pic && admin.profile_pic != '' ? admin.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:4}}
                    resizeMode='cover'
                />
                :<></>}
                <View transparent style={{ flex:1, marginLeft:20, marginRight:20 }}>
                    <Text theme='h2'>{is_closed ? 'TOTAL PAID OUT': 'CURRENT PAYOUT'}</Text>
                    {is_closed ?
                    <Text style={{ marginTop:3 }} color={Colors.text.gold} weight='bold' size={12}>COMPLETED</Text>
                    :is_live ? 
                    <Text style={{ marginTop:3 }} color={Colors.text.error} weight='bold' size={12}>AUCTION COMPLETE</Text>
                    :
                    <Text style={{ marginTop:3 }} theme='light'>Auction Ends {moment(squares_competition.begin_datetime).fromNow()}</Text>
                    }
                </View>
                <Text color={Colors.text.success} size={20} weight='bold'>${current_payout.toFixed(2)}</Text>
            </View>
        </Button>
    )
}

export default SquaresCompetitionCard